var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"systemInfo"},[_vm._v(" System mit"),_c('br'),_vm._v(" "+_vm._s(this.$serverUrl().includes("/backend") ? "Produktiv" : "Entwicklungs")+" "),_c('br'),_vm._v("Datenbank ")])
}
var staticRenderFns = []

export { render, staticRenderFns }